import { WifiMark } from "./WifiMark";

const DEFAULT_PHRASES = ["Disconnect to Reconnect", "Rich Offline", "Luxury in Isolation", "Signal Not Found"];

const Strip = ({ phrases }) => (
    <div className="flex items-center shrink-0">
        {phrases.map((p, i) => (
            <span key={i} className="flex items-center">
                <span className="font-serif italic text-2xl sm:text-4xl text-zinc-300 px-10 sm:px-16 whitespace-nowrap">
                    {p}
                </span>
                <WifiMark className="h-5 w-auto shrink-0" pulsing={false} />
            </span>
        ))}
    </div>
);

export const Marquee = ({ phrases = DEFAULT_PHRASES }) => (
    <div className="relative border-y border-zinc-800/80 py-8 sm:py-10 overflow-hidden" data-testid="editorial-marquee">
        <div className="marquee-track flex w-max">
            <Strip phrases={phrases} />
            <Strip phrases={phrases} />
        </div>
    </div>
);
